import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Link } from '~/components/Link'

import { IUser } from '~/types/user-info-types'
import { useAppSelector } from '~/redux/hooks'
import { isAuthenticated, selectUserIsSchoolTeacher } from '~/auth/slices/auth.slice'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '40px' }]

export default function Unranked({ user }: { user: IUser | null }): React.ReactElement {
  const { t } = useTranslation(['leaderboard', 'subscription'])
  const authenticated = useAppSelector(isAuthenticated)
  // School teachers are deliberately excluded from league boards, so "earn XP to join" is an
  // invitation they can never act on.
  const isSchoolTeacher = useAppSelector(selectUserIsSchoolTeacher)
  const purpleLightTop = '#9F7CFF'
  const purpleDarkTop = '#7945FF'

  return (
    <div className="flex flex-col items-center justify-center pt-20">
      <div className="relative bg-black bg-opacity-80 rounded px-6 py-4 mx-4 max-w-75 w-full h-full flex flex-col backdrop-blur-none">
        <h2 className="text-2xl text-white text-center">
          {isSchoolTeacher ? t('leaderboard:teacherComingSoon') : t('leaderboard:joinLeaderboard')}
        </h2>
        {authenticated && (
          <Link
            className="flex justify-center items-center text-center text-md border border-white bg-gradient-purple-light-top p-2 rounded z-20 mt-1.5 hover:bg-gradient-black-transparent bg-purple transition-colors duration-300"
            to="/dashboard"
          >
            <span className="w-7" />
            <span className="mx-auto">{t('subscription:success.goHomeButton')}</span>
            <ResponsiveImage height={28} imageWidths="28" srcKey="icons/home-v2.png" width={28} />
          </Link>
        )}
        <div className="absolute z-10 inset-0 overflow-hidden" style={{ borderRadius: '11' }}>
          <svg height="100%" width="100%">
            <defs>
              <linearGradient id="grad" x2="0%" y2="100%">
                <stop offset="0%" stopColor={purpleLightTop} />
                <stop offset="100%" stopColor={purpleDarkTop} />
              </linearGradient>
            </defs>
            <rect fill="transparent" height="100%" rx={11} stroke="url(#grad)" strokeWidth="4" width="100%" />
          </svg>
        </div>
      </div>
      <div className={`absolute left-0 right-0 mx-auto -z-1 ${user ? '-mt-36' : ''} flex justify-center`}>
        <ResponsiveImage
          alt={t('leaderboard:background')}
          className=""
          height={317}
          srcKey="gamification/bg-leaderboard.svg"
          width={418}
        />
      </div>
      {user?.id && (
        <div className="pt-16" style={{ maxWidth: 'calc(100vw - 24px)' }}>
          <p>{t('leaderboard:unranked')}</p>

          <div className="flex items-center p-2 gap-4 w-full">
            <ResponsiveImage
              alt={t('leaderboard:avatar')}
              height={40}
              imageClassName="rounded-full"
              imageWidths="40"
              mediaQuery={mediaQuery}
              srcKey={user?.avatarPngUrl ? user?.avatarPngUrl : 'avatar-portraits/hom-default-avatar.png'}
              width={40}
            />
            <p className="shrink text-ellipsis overflow-hidden max-w-[225px] whitespace-nowrap">{user?.nickname}</p>
          </div>
        </div>
      )}
    </div>
  )
}
